import styled, { css } from 'styled-components/macro';
import { Field as FieldFormik } from 'formik';
import { applyStyleModifiers } from 'styled-components-modifiers';

const FIELD_MODIFIERS = {
  error: ({ theme }) => `
    border-bottom: ${theme.values.borderSize} solid ${theme.colors.danger};
  `,
};

export const inputStyle = css`
  color: ${props => props.theme.colors.base};
  padding: ${props => `${props.theme.spacing.xs2} 0`};
  font-size: ${props => props.theme.sizes.s};
  font-weight: ${props => props.theme.weight.light};
  width: 100%;
  &::placeholder {
    color: ${props => props.theme.colors.grey};
  }
  border: 0;
  border-bottom: ${props => props.theme.values.borderSize} solid
    ${props => props.theme.colors.base};
  background-color: transparent;

  &:focus {
    outline: 0;
    border-bottom: ${props => props.theme.values.borderSize} solid
      ${props => props.theme.colors.base};
  }
  ${applyStyleModifiers(FIELD_MODIFIERS)};
`

const Field = styled(FieldFormik)`
  ${inputStyle};
`;

export default Field;
